import CommonApi from './../commonApi';
const pddTicket = new CommonApi('pddTicket', 'Билеты ПДД');
export default {
  ...pddTicket
};
